import { render, staticRenderFns } from "./Stockist_reg.vue?vue&type=template&id=8781d75a"
import script from "./Stockist_reg.vue?vue&type=script&lang=js"
export * from "./Stockist_reg.vue?vue&type=script&lang=js"
import style0 from "./Stockist_reg.vue?vue&type=style&index=0&id=8781d75a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports